import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef, useRef, useImperativeHandle } from 'react';
import { EventsByTriggerNeed } from './declarations/Tooltip.types.js';
import defaultStyles from './styles/Tooltip.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { pick } from '../../utils/pick.js';
import { Trigger } from '../trigger/Trigger.js';

const Tooltip = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    children,
    trigger = 'hover',
    position = 'top',
    popupVisible,
    disabled,
    triggerProps,
    content,
    mini,
    offset = [0, 17],
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const refTrigger = useRef();
  useImperativeHandle(ref, () => refTrigger.current, []);
  const otherProps = {
    ...pick(rest, EventsByTriggerNeed),
    ...triggerProps
  };

  // it is important to note that this method has its limitations
  // it fails in cases such as content = <>&nbsp;&nbsp;</>
  const isEmpty = _content => {
    if (_content === null || _content === undefined || _content === false || typeof _content === 'string' && _content.trim() === '') {
      return true;
    }
  };
  if (popupVisible) {
    otherProps.popupVisible = popupVisible;
  } else if (isEmpty(content)) {
    // hide if empty content
    otherProps.popupVisible = false;
  }
  if (otherProps.withArrow !== false || otherProps.arrowProps) {
    otherProps.arrowProps = otherProps.arrowProps || {};
  }
  return /*#__PURE__*/jsx(Trigger, {
    content: /*#__PURE__*/jsx("div", {
      role: "tooltip",
      className: clsx(styles.root, {
        [styles.mini]: mini
      }),
      children: content
    }),
    position: position,
    disabled: disabled,
    trigger: trigger,
    withArrow: false,
    offset: offset,
    ...otherProps,
    children: children
  });
});
Tooltip.displayName = 'Tooltip';

export { Tooltip };
